import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.patents' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
